
































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Watch, Ref } from 'vue-property-decorator';
import BannerListStaticData from '@/components/banner/mixin/BannerListStaticData';
import PageLeaveGuardVue from '@/components/common/mixin/PageLeaveGuard';
import MallTab from '@/components/common/MallTab.vue';
import TuiTree, { TreeNodeData } from '@/components/banner/TuiTree.vue';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import CompCheckBox from '@/components/common/CompCheckBoxButton.vue';
import DateCalendar from '@/components/common/datepicker/DateCalendar.vue';
import ColorPickerButton from '@/components/common/colorpicker/ColorPickerButton.vue';
import ControllerBannerDescription from '@/components/banner/ControllerBannerDescription.vue';
import ControllerBannerImageMap from '@/components/banner/ControllerBannerImageMap.vue';
import moment from 'moment';
import { ncpPopup } from '@/utils/commonUtils';
import { addMonth, getToday } from '@/utils/dateUtils';
import {
  replaceObjectKeyName,
  arrayElementSwap,
  clone,
  range,
  encodeRadioAllOrNoneOrAny,
  decodeRadioAllOrNoneOrAny,
  EncodeNoneAllAnyOption,
  NoneAllAnyOption,
} from '@/utils/dataReplaceUtils';
import { namespace } from 'vuex-class';
import {
  CommonData,
  ChangeSelectTreeEmit,
  MemberGradeDisplay,
  MemberGroupDisplay,
  AccountData,
  Banner,
  BannerDescriptionPopupProp,
  PopupBannerDisplayOptionData,
  PlatformDisplayYn,
} from '@/types/banner';
import { CheckBoxOptionData, CheckBoxOptions } from '@/types/common';
import {
  Mall,
  GetBannerGroups,
  GetBannerGroupsBannerSections,
  Grade,
  Group,
  GetBannerGroupsBanner,
  Account,
  Image,
  GetMemberGroupsRequest,
  GetMemberGradesRequest,
  GetBannerGroupsBannerSectionsRequest,
  LandingUrl,
  PostBannerGroupsRequest,
  BannerAccount,
  DeleteBannerGroupsBannerGroupNoRequest,
  DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest,
  PutBannerGroupBannerGroupNoRequest,
  PutBannerGroupsBannerGroupNoOrderRequest,
  PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrderRequest,
  platformDisplay,
} from 'supporter';
import { isEqual, intersection } from 'underscore';
import LengthCounter from '@/components/common/input/LengthCounter.vue';

const mallModule = namespace('mall');
const bannerModule = namespace('banner');
const memberGradeModule = namespace('memberGrade');
const memberGroupModule = namespace('memberGroup');

declare global {
  interface Window {
    emitChildData?: (data: AccountData, sectionNo: number) => void;
  }
}

interface DateCalendarOption {
  dateType: string; // 'YmdHm' | 'Ymd' | ...;
  name: string;
  fromRanges?: string;
  endDate?: boolean;
  detailTime?: boolean;
}

interface DisplayPeriod {
  startYmdt: string;
  endYmdt: string;
}

@Component({
  components: {
    LengthCounter,
    MallTab,
    TuiTree,
    CompSelectBox,
    CompRadioButton,
    CompCheckBox,
    DateCalendar,
    ColorPickerButton,
    ControllerBannerDescription,
    ControllerBannerImageMap,
  },
})
// TODO. 다시 짜야할듯.. 변경되는 state 가 너무많아서 파악이 힘듬..
export default class BannerList extends Mixins(BannerListStaticData, PageLeaveGuardVue) {
  @mallModule.State('malls')
  private readonly malls!: Mall[];
  @bannerModule.Getter('bannerGroupList')
  private readonly bannerGroupList: GetBannerGroups[];
  @bannerModule.Getter('bannerSectionData')
  private readonly bannerSectionData: GetBannerGroupsBannerSections;
  @bannerModule.Getter('groupNo')
  private readonly groupNo: number;
  @memberGradeModule.Getter('memberGradeUsedList')
  private readonly memberGradeUsedList: Grade[];
  @memberGroupModule.Getter('memberGroupList')
  private memberGroupList: Group[];
  @bannerModule.Action('getBannerGroups')
  private getBannerGroups: Function;
  @bannerModule.Action('getBannerGroupsBannerSections')
  private getBannerGroupsBannerSections: (payload: GetBannerGroupsBannerSectionsRequest) => Promise<void>;
  @bannerModule.Action('postBannerGroups')
  private postBannerGroups: (payload: PostBannerGroupsRequest) => Promise<void>;
  @bannerModule.Action('postBannerSections')
  private postBannerSections: (payload) => Promise<void>;
  @bannerModule.Action('putBannerGroup')
  private putBannerGroup: (payload: PutBannerGroupBannerGroupNoRequest) => Promise<void>;
  @bannerModule.Action('putBannerSection')
  private putBannerSection: (payload) => Promise<void>;

  @bannerModule.Action('putBannerGroupOrder')
  private putBannerGroupOrder: (payload: PutBannerGroupsBannerGroupNoOrderRequest) => Promise<void>;
  @bannerModule.Action('putBannerSectionOrder')
  private putBannerSectionOrder: (
    payload: PutBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoOrderRequest,
  ) => Promise<void>;

  @bannerModule.Action('deleteBannerGroup')
  private deleteBannerGroup: (payload: DeleteBannerGroupsBannerGroupNoRequest) => Promise<void>;
  @bannerModule.Action('deleteBannerSection')
  private deleteBannerSection: (
    payload: DeleteBannerGroupsBannerGroupNoBannerSectionsBannerSectionNoRequest,
  ) => Promise<void>;
  @memberGradeModule.Action('getMemberGrades')
  private getMemberGrades: (payload: GetMemberGradesRequest) => Promise<void>;
  @memberGroupModule.Action('fetchMemberGroups')
  private getMemberGroups: (payload: GetMemberGroupsRequest) => Promise<void>;

  @Ref() private readonly tuiTree!: TuiTree;
  @Ref() private readonly inputVideoUrl!: HTMLInputElement;
  @Ref() private readonly bannerImageFileInput!: HTMLInputElement[];
  @Ref() private readonly bannerMouseOverImageFileInput!: HTMLInputElement[];

  /**
   * from Mixin data
   *
   * @platformDisplayOptions
   * @memberGradeDisplayOptions
   * @memberGroupDisplayOptions
   * @memberGradeDetailDisplayOptions
   * @memberGroupDetailDisplayOptions
   * @landingUrlTypes
   * @openLocationTypes
   * @displayPeriodOptions
   * @defaultCommonData
   * @defaultBannerData
   * @defaultAccountData
   * @defaultAccountsData
   *
   * @see @/components/banner/mixin/BannerListStaticData.ts
   */

  private commonData: CommonData = this.defaultCommonData();
  private accountsData: AccountData[] = this.defaultAccountsData(1);
  private isGroupTree: boolean = true;
  private isNewBorn: boolean = false;
  private prevCommonTitle: string | null = null;
  private hasLandingUrl: boolean = true;
  private landingUrlIdx: number = 0;
  private trees = [];
  private isSectionAdditionAfterSaving = false;
  private isClickAddSection = false;

  get mallNo(): string {
    const mallNo = this.$route.query?.mallNo;
    return mallNo !== undefined ? mallNo.toString() : this.malls[0].mallNo.toString();
  }

  get commonPlatformDisplayYn(): PlatformDisplayYn {
    const { displayPc, displayMobile, displayMobileWeb } = this.commonData.platformDisplay;

    return {
      displayPcYn: displayPc ? 'Y' : 'N',
      displayMobileYn: displayMobile ? 'Y' : 'N',
      displayMobileWebYn: displayMobileWeb ? 'Y' : 'N',
    };
  }

  @Watch('$route.query.mallNo')
  onRouteChanged(newVal: number, oldVal: number) {
    if (newVal === undefined) {
      this.reset();
      return;
    }

    if (oldVal !== undefined) {
      this.setBannerGroups();
    }
  }

  get mallName(): string {
    return this.malls.find(mall => mall.mallNo.toString() === this.mallNo)?.mallName || '';
  }

  get isCelibacy(): boolean {
    if (!this.isGroupTree || !this.commonData.groupNo) return false;
    const tree = this.trees.find(tree => tree.groupNo === this.commonData.groupNo);
    const howManyChild = tree?.children.length;
    return !howManyChild;
  }

  private reset(): void {
    this.customValidationInit();
    this.cleanUpSessionStorage();
    this.fetchBannerGroups();
  }

  private setBannerGroups(): void {
    this.commonData = this.defaultCommonData();
    this.accountsData = this.defaultAccountsData(1);
    this.fetchBannerGroups(true);
  }

  private setAccountsData(accounts: Account[]) {
    const nullImageBindKey = (image): Image => (!image ? { imageName: '', imageUrl: '' } : image);
    this.accountsData = clone(accounts)
      .map(
        (account): AccountData => {
          account.banners.map(
            (banner): Banner => {
              banner.imageInfo = nullImageBindKey(banner.imageInfo);
              banner.mouseOverImage = nullImageBindKey(banner.mouseOverImage);
              banner.useMouseOver = banner.mouseOverImage.imageName !== '';
              if (banner.landingUrlValue.bannerOpenLocationType === 'REF_URL') {
                banner.landingUrlValue.bannerOpenLocationType = 'CURRENT';
              }

              return banner;
            },
          );
          return account;
        },
      )
      .sort((prev, next) => prev.accountNo - next.accountNo);
  }

  // 배너 구좌 수
  private numberOfCounts(howMany: number) {
    return range(howMany).map(idx => ({
      value: idx + 1,
      name: `${idx + 1}${this.$t('COMMON_CASE')}`,
    }));
  }

  @Watch('commonData.numberOfCount')
  private numberOfCountChangeGuard(howMany: number): void {
    const beforeAccountHowMany: number = this.accountsData.length;

    if (beforeAccountHowMany === howMany) return;

    if (beforeAccountHowMany > howMany) {
      if (confirm(this.$t('BANNER_LIST_CONFIRM_ACCOUNT_DOWN_SIZING').toString())) {
        this.accountLengthChange(howMany, true);
      } else {
        this.commonData.numberOfCount = beforeAccountHowMany;
      }
      return;
    }

    if (howMany > beforeAccountHowMany) {
      this.accountLengthChange(howMany);
    }
  }

  private accountLengthChange(howMany: number, decrement: boolean = false): void {
    const beforeAccountHowMany: number = this.accountsData.length;
    if (beforeAccountHowMany === howMany) return;

    if (decrement) {
      this.accountsData = this.accountsData.splice(0, howMany);
      return;
    }

    const count: number = howMany - beforeAccountHowMany;

    const temporaryAccountsData = clone(this.accountsData);
    range(count).forEach(() => {
      temporaryAccountsData.push(this.defaultAccountData(1));
    });

    this.accountsData = temporaryAccountsData.map((account, idx) => {
      if (account.accountName === '') account.accountName = `${this.$t('BANNER_LIST_NUMBER_OF').toString()} ${idx + 1}`;
      return account;
    });
  }

  private setCommonData(data: GetBannerGroupsBannerSections): void {
    this.commonData.sectionCode = data.sectionCode;
    this.commonData.groupNo = data.groupNo;
    this.commonData.numberOfCount = data.accounts.length;

    this.setPlatformDisplayOption(data.platformDisplay);
  }

  @Watch('platformDisplayOption')
  private changePlatformDisplay(){
   if(this.platformDisplayOption !== 'NONE') return;
   this.$set(this.commonData.platformDisplay, 'displayPc', true)
   this.$set(this.commonData.platformDisplay, 'displayMobile', true)
   this.$set(this.commonData.platformDisplay, 'displayMobileWeb', true)
  }

  private platformDisplayOption = 'NONE';
  private setPlatformDisplayOption(options: platformDisplay): void {
    const isDisplay = yesOrNo => yesOrNo === 'Y';
    const isAllDisplay =
      isDisplay(options.displayMobileWebYn) && isDisplay(options.displayMobileYn) && isDisplay(options.displayPcYn);

    this.commonData.platformDisplay.displayMobileWeb = isDisplay(options.displayMobileWebYn);
    this.commonData.platformDisplay.displayMobile = isDisplay(options.displayMobileYn);
    this.commonData.platformDisplay.displayPc = isDisplay(options.displayPcYn);
    this.platformDisplayOption = isAllDisplay ? 'NONE' : 'ANY';
  }

  // 회원 등급 노출/회원 그룹 노출 설정
  private setMemberGradeDisplayOption(memberGradeDisplay: MemberGradeDisplay): void {
    const currentGradeNos = this.memberGradeUsedList.map(group => group.no);
    memberGradeDisplay.info = memberGradeDisplay.info.filter(v => currentGradeNos.includes(v));
    const memberGradeDisplayInfo = encodeRadioAllOrNoneOrAny(memberGradeDisplay, 'member_grade');

    this.commonData.memberGradeDisplay.check = memberGradeDisplayInfo.check;
    this.commonData.memberGradeDisplay.info = memberGradeDisplayInfo.info;
  }

  // pin
  private setMemberGroupDisplayOption(memberGroupDisplay: MemberGroupDisplay): void {
    const currentGroupNos = this.memberGroupList.map(group => group.no);
    memberGroupDisplay.info = memberGroupDisplay.info.filter(v => currentGroupNos.includes(v));
    const memberGroupDisplayInfo = encodeRadioAllOrNoneOrAny(memberGroupDisplay, 'member_group');

    this.commonData.memberGroupDisplay.check = memberGroupDisplayInfo.check;
    this.commonData.memberGroupDisplay.info = memberGroupDisplayInfo.info;
  }

  private setDetailDisplayOption<T extends Grade | Group>(list: T[], options: CheckBoxOptions, id: string): void {
    const newOptions = list.map(item => ({
      id: `${id}-${item.no}`,
      value: `${id}-${item.no}`,
      dispaly: item.name.toString(),
    }));

    options.data = [...options.data, ...newOptions].reduce((acc, item) => {
      !acc.find(({ id }) => item.id === id) && acc.push(item);
      return acc;
    }, []);
  }

  private displayPeriodStartYmdtOption(uid: string, range: string): DateCalendarOption {
    const dateTime = moment(range)
      .toDate()
      .getTime();
    const todayDateTime = new Date().getTime();
    const isTodayHigher = todayDateTime - dateTime > 0;

    return {
      dateType: 'YmdHm',
      name: `salePeriodInfoStartYmdt_${uid}`,
      fromRanges: isTodayHigher ? moment(range).format('YYYY-MM-DD') : getToday(),
      endDate: false,
      detailTime: true,
    };
  }

  private displayPeriodEndYmdtOption(uid: string): DateCalendarOption {
    return {
      dateType: 'YmdHm',
      name: `salePeriodInfoEndYmdt_${uid}`,
      endDate: true,
      detailTime: true,
    };
  }

  created() {
    this.customValidationInit();
  }

  mounted() {
    this.cleanUpSessionStorage();
    this.fetchBannerGroups();
  }

  private customValidationInit(): void {
    this.customValidation = () => {
      const beforeCommonData = JSON.parse(sessionStorage.getItem('beforeCommonData'));
      const beforeAccountsData = JSON.parse(sessionStorage.getItem('beforeAccountsData'));

      beforeCommonData.groupNo = this.commonData.groupNo;
      const hasCommonDataChanged = !isEqual(this.commonData, beforeCommonData);
      const hasAccountsDataChanged = !isEqual(this.accountsData, beforeAccountsData);

      return !(hasCommonDataChanged || hasAccountsDataChanged);
    };
  }

  private isChangedData() {
    if (!this.customValidation) return;

    return !this.customValidation();
  }

  private async fetchBannerGroups(resetPosition = false) {
    return this.getBannerGroups({
      params: {
        mallNo: Number(this.mallNo),
      },
    })
      .then(() => this.setTreesData())
      .then(() => this.tuiTree?.resetTree(resetPosition))
      .then(() => {
        sessionStorage.setItem('beforeCommonData', JSON.stringify(this.commonData));
        sessionStorage.setItem('beforeAccountsData', JSON.stringify(this.accountsData));
      });
  }

  private async fetchSectionData(sectionNo: number, isNewSection: boolean = false) {
    await this.setMemberLevelOptions();
    if (isNewSection) {
      this.addNewSection();
      return;
    }
    try {
      await this.getBannerGroupsBannerSections({
        params: {
          bannerSectionNo: String(sectionNo),
          mallNo: Number(this.mallNo),
        },
      });

      this.setAccountsData(this.bannerSectionData.accounts);
      this.setCommonData(this.bannerSectionData);
      this.setMemberGradeDisplayOption(this.bannerSectionData.memberGradeDisplayInfo);
      this.setMemberGroupDisplayOption(this.bannerSectionData.memberGroupDisplayInfo);
    } catch (error) {
      if (error.data?.path.replace(/[0-9]/g, '') === '/banner-groups/banner-sections/') {
        this.wrongAccessHandler(error.data.result.message);
        this.$router.go(-1);
      }
    }

    sessionStorage.setItem('beforeCommonData', JSON.stringify(this.commonData));
    sessionStorage.setItem('beforeAccountsData', JSON.stringify(this.accountsData));
  }

  private async setMemberLevelOptions() {
    if (!this.memberGradeUsedList.length) {
      await this.getMemberGrades({
        params: {
          mallNo: Number(this.mallNo),
        },
      });
    } else {
      this.setMemberGrade();
    }
    if (!this.memberGroupList.length) {
      await this.getMemberGroups({
        params: {
          mallNo: Number(this.mallNo),
        },
      });
    } else {
      this.setMemberGroup();
    }
  }

  @Watch('memberGradeUsedList')
  setMemberGrade() {
    this.setDetailDisplayOption<Grade>(this.memberGradeUsedList, this.memberGradeDetailDisplayOptions, 'member_grade');
  }

  @Watch('memberGroupList')
  setMemberGroup() {
    this.setDetailDisplayOption<Group>(this.memberGroupList, this.memberGroupDetailDisplayOptions, 'member_group');
  }

  private addNewSection(): void {
    this.accountsData = this.defaultAccountsData(1);
    this.commonData.sectionCode = '';

    this.acceptLeave = false;
  }

  private onClickSubmit(isSectionAdditionAfterSaving = false): boolean {
    this.isSectionAdditionAfterSaving = isSectionAdditionAfterSaving
    if (this.isGroupTree) {
      if (!this.groupFieldValidate()) {
        return false;
      }

      if (this.commonData.groupNo) {
        this.putGroupData();
      } else {
        this.postGroupData();
      }

      this.acceptLeave = true;
    } else {
      if (!this.sectionFieldValidate()) {
        return false
      }

      if (this.commonData.sectionNo) {
        this.putSectionData();
      } else {
        this.postSectionData();
      }

      this.acceptLeave = true;
    }
    return true
  }

  private onChangeOrder(data: { type: 'GROUP' | 'SECTION'; prev: TreeNodeData; next: TreeNodeData; parent?: TreeNodeData }): void {
    switch (data.type) {
      case 'GROUP':
        this.putGroupOrderData(data.next);
        break;
      case 'SECTION':
        this.putSectionOrderData(data.prev, data.next, data.parent);
        break;
    }
  }

  private postGroupData(isValid: boolean = false): void {
    if (!isValid) return;

    const groupName = this.commonData.title;

    this.postBannerGroups({
      groupName,
      mallNo: Number(this.mallNo),
    })
      .then(() => {
        this.commonData.groupNo = this.groupNo;
        this.tuiTree.topLevelIconReplacement();
        if (!isValid) alert(this.$t('BANNER_LIST_SAVE_SUCCESS'));
      })
      .then(() => {
        this.updateTrees(this.commonData.groupNo, groupName);
      });
  }

  private postSectionData(): void {
    const bannerAccounts: BannerAccount[] = clone(this.accountsData).map((account: AccountData) => ({
      // BannerAccount
      accountName: account.accountName,
      accountDisplayType: account.displayType,
      accountWidth: Number(account.width),
      accountHeight: Number(account.height),
      platformDisplay: account.platformDisplay,
      memberGradeDisplayInfo: decodeRadioAllOrNoneOrAny(account.memberGradeDisplayInfo),
      memberGroupDisplayInfo: decodeRadioAllOrNoneOrAny(account.memberGroupDisplayInfo),
      banners: account.banners.map(banner => ({
        bannerName: banner.bannerName,
        bannerNameColor: banner.bannerNameColor,
        displayOrder: banner.displayOrder,
        bannerDescription: banner.description,
        bannerDescriptionColor: banner.descriptionColor,
        leftImageSpaceColor: banner.leftImageSpaceColor,
        rightImageSpaceColor: banner.rightImageSpaceColor,
        videoUrl: banner.videoUrl,
        bannerImage: banner.imageInfo,
        bannerMouseOverImage: banner.mouseOverImage,
        landingUrlValue: {
          ...banner.landingUrlValue,
          landingUrl: banner.landingUrlValue.landingUrl.trim()
        },
        bannerDisplayPeriod: banner.displayPeriod,
      })),
    }));
    this.postBannerSections({
      pathParams: {
        bannerGroupNo: Number(this.commonData.groupNo),
      },
      data: {
        bannerAccounts: [...bannerAccounts],
        mallNo: Number(this.mallNo),
        bannerSectionName: this.commonData.title,
        platformDisplay: this.commonPlatformDisplayYn,
        memberGradeDisplayInfo: decodeRadioAllOrNoneOrAny(this.commonData.memberGradeDisplay),
        memberGroupDisplayInfo: decodeRadioAllOrNoneOrAny(this.commonData.memberGroupDisplay),
      },
    })
      .then(async () => {
        this.isClickAddSection = false;
        await this.fetchBannerGroups();
        alert(this.$t('BANNER_LIST_SAVE_SUCCESS'));
      });
  }

  private putGroupData(): void {
    const groupName = this.commonData.title;

    this.putBannerGroup({
      pathParams: {
        bannerGroupNo: this.commonData.groupNo.toString(),
      },
      data: {
        groupName,
        mallNo: Number(this.mallNo),
      },
    })
      .then(() => {
        alert(this.$t('BANNER_LIST_SAVE_SUCCESS'));
      })
      .then(() => {
        this.fetchBannerGroups();
      });
  }

  private putSectionData() {

    const memberGradeDisplayInfo = decodeRadioAllOrNoneOrAny(this.commonData.memberGradeDisplay);
    const memberGroupDisplayInfo = decodeRadioAllOrNoneOrAny(this.commonData.memberGroupDisplay);

    const bannerAccounts: BannerAccount[] = clone(this.accountsData).map((account: AccountData) => {
      // 섹션구좌는 섹션에서 설정한 등급 이하 만을 가질 수 있다. 섹션 값만 수정되었을 때에 이 함수로 이를 보정함..
      const checkOverCase = ({ check, info }: EncodeNoneAllAnyOption, parent) => {
        const result: NoneAllAnyOption = {
          check,
          info: [],
        };
        switch (check) {
          case 'NONE':
            // console.log('case 1');
            if (parent.check === 'ALL' || parent.check === 'ANY') {
              result.check = parent.check;
              result.info = parent.info;
            }
            break;
          case 'ALL':
            // console.log('case 2');
            if (parent.check === 'ANY') {
              result.check = parent.check;
              result.info = parent.info;
            }
            break;
          case 'ANY':
            switch (parent.check) {
              case 'NONE':
                // console.log('case 3');
                result.info = (info as unknown) as number[];
                break;
              case 'ALL':
                // console.log('case 4');
                result.info = (info as unknown) as number[];
                break;
              case 'ANY':
                // console.log('case 5');
                result.info = intersection((info as unknown) as number[], parent.info);
                break;
            }

            break;
        }
        return result;
      };

      const accountMemberGradeDisplayInfo = checkOverCase(account.memberGradeDisplayInfo, memberGradeDisplayInfo);
      const accountMemberGroupDisplayInfo = checkOverCase(account.memberGroupDisplayInfo, memberGroupDisplayInfo);

      // BannerAccount
      return {
        accountName: account.accountName,
        accountNo: account.accountNo,
        accountDisplayType: account.displayType,
        accountWidth: Number(account.width),
        accountHeight: Number(account.height),
        platformDisplay: account.platformDisplay,
        memberGradeDisplayInfo: accountMemberGradeDisplayInfo,
        memberGroupDisplayInfo: accountMemberGroupDisplayInfo,
        banners: account.banners.map(banner => ({
          bannerNo: banner.bannerNo ? banner.bannerNo : 0,
          bannerName: banner.bannerName,
          bannerNameColor: banner.bannerNameColor,
          displayOrder: banner.displayOrder,
          bannerDescription: banner.description,
          bannerDescriptionColor: banner.descriptionColor,
          leftImageSpaceColor: banner.leftImageSpaceColor,
          rightImageSpaceColor: banner.rightImageSpaceColor,
          videoUrl: banner.videoUrl,
          bannerImage: banner.imageInfo,
          bannerMouseOverImage: banner.mouseOverImage,
          landingUrlValue: {
            ...banner.landingUrlValue,
            landingUrl: banner.landingUrlValue.landingUrl.trim()
          },
          bannerDisplayPeriod: banner.displayPeriod,
        })),
      };
    });
    this.putBannerSection({
      pathParams: {
        bannerGroupNo: this.commonData.groupNo.toString(),
        bannerSectionNo: this.commonData.sectionNo.toString(),
      },
      data: {
        bannerAccounts: [...bannerAccounts],
        mallNo: Number(this.mallNo),
        bannerSectionName: this.commonData.title,
        platformDisplay: this.commonPlatformDisplayYn,
        memberGradeDisplayInfo,
        memberGroupDisplayInfo,
      },
    })
      .then(() => {
        this.fetchBannerGroups();
        alert(this.$t('BANNER_LIST_SAVE_SUCCESS'));
      })
      .catch(error => {
        console.error(error);
      });
  }

  private putGroupOrderData(next: TreeNodeData): void {
    this.putBannerGroupOrder({
      pathParams: {
        bannerGroupNo: next.groupNo?.toString(),
      },
      data: {
        newOrder: next.displayOrder,
        mallNo: Number(this.mallNo),
      },
    });
  }

  private putSectionOrderData(prev: TreeNodeData, next: TreeNodeData, parent: TreeNodeData): void {
    // 상위 노드는 groupNo 를 가지고 있음
    // 하위 노드는 sectionNo 를 가지고 있음
    // sectionNo 는 각 노드의 고유 id 를 가지고 있어서 순서이동이 생기더라도 변하지 않음
    // groupNo 는 부모의 노드이기 때문에 순서이동 시 변경될 수 있음
    // tui-tree 를 제대로 wrapping 된 컴포넌트를 만들어 사용해야할 필요가 있음 (SaaS 작업 때 하자 제발)
    this.putBannerSectionOrder({
      pathParams: {
        bannerGroupNo: prev.groupNo?.toString(), // 현재
        bannerSectionNo: next.sectionNo?.toString(), // 현재
      },
      data: {
        newOrder: next.displayOrder, // 미래
        newGroupNo: parent.groupNo, // 미래
        mallNo: Number(this.mallNo),
      },
    });
  }

  private deleteGroupData(): void {
    this.deleteBannerGroup({
      pathParams: {
        bannerGroupNo: this.commonData.groupNo.toString(),
        mallNo: this.mallNo,
      },
    }).then(() => {
      this.fetchBannerGroups();
      if (this.bannerGroupList.length === 0) this.trees = [];
    });
  }

  private deleteSectionData(): void {
    this.deleteBannerSection({
      pathParams: {
        bannerGroupNo: this.commonData.groupNo.toString(),
        bannerSectionNo: this.commonData.sectionNo.toString(),
        mallNo: this.mallNo,
      },
    })
      .then(() => {
        alert(this.$t('BANNER_LIST_SAVE_SUCCESS'));
        // this.$router.go(0); // legacy
      })
      .then(() => {
        this.fetchBannerGroups();
      });
  }
  private groupFieldValidate(): boolean {
    const onChanged = this.commonData.title !== this.prevCommonTitle;

    if (!onChanged) {
      alert(this.$t('BANNER_LIST_ALERT_NO_CHANGE'));
      return false;
    }

    return true;
  }

  private sectionFieldValidate(): boolean {
    // if (this.accountsData[0].accountNo === 0) {
    //   this.wrongAccessHandler();
    //   return false;
    // }

    if (!this.hasBannersSize) {
      alert(this.$t('BANNER_LIST_ALERT_SECTION_SIZE_EMPTY'));
      return false;
    }

    if (!this.hasBannerVisual) {
      alert(this.$t('BANNER_LIST_ALERT_BANNER_VISUAL_EMPTY'));
      return false;
    }

    if (!this.hasLandingUrl) {
      this.hasLandingUrl = false;
      alert(this.$t('BANNER_LIST_ALERT_LANDING_URL_EMPTY'));
      this.$refs.inputLandingUrl[this.landingUrlIdx].focus();
      return false;
    }

    if (!this.isChangedData()) {
      alert(this.$t('BANNER_LIST_ALERT_NO_CHANGE'));
      return false;
    }

    return true;
  }

  get hasBannersSize(): boolean {
    return this.accountsData.every((account, idx) => {
      const hasWidth = !!account.width;
      const hasHeight = !!account.height;

      if (!hasWidth) {
        this.$refs.accountWidthInput[idx].focus();
        return false;
      }

      if (!hasHeight) {
        this.$refs.accountHeightInput[idx].focus();
        return false;
      }

      return true;
    });
  }

  get hasBannerVisual(): boolean {
    this.hasLandingUrl = true;
    this.landingUrlIdx = 0;

    let inputIdx = -1; // 0부터 시작
    return this.accountsData.every(account => {
      return account.banners.every(banner => {
        inputIdx++;

        const hasImage = !!banner.imageInfo.imageUrl;
        const hasVideo = !!banner.videoUrl;

        if (!hasImage && !hasVideo) {
          this.inputVideoUrl[inputIdx].focus();
          return false;
        }

        if (hasImage) {
          this.hasLandingUrl = !!banner.landingUrlValue.landingUrl.trim();
          this.landingUrlIdx = inputIdx;
        }

        return true;
      });
    });
  }

  private setTreesData(nodeData?) {
    const newKeys = {
      groupName: 'text',
      sectionName: 'text',
      sectionNodes: 'children',
    };
    if (this.bannerGroupList.length) {
      this.trees = replaceObjectKeyName<GetBannerGroups>(this.bannerGroupList, newKeys).map(item => {
        item.state = 'close';
        return item;
      });
    } else if (nodeData) {
      this.trees.push({
        depth: 1,
        text: nodeData.text,
        displayYn: 'Y',
      });
    } else {
      this.trees = [];
    }
  }

  private addGroupTree(): void {
    this.tuiTree.addTree(this.$t('BANNER_LIST_NEW_GROUP').toString(), {
      editAfterAdding: false,
      addToSelectedDepth: false,
    });
    this.postGroupData(true);
  }

  private addSectionTree(event: any): void {
    this.isClickAddSection = Boolean(event)
    this.isSectionAdditionAfterSaving = false;
    this.isNewBorn = true;
    this.tuiTree.addTree(this.$t('BANNER_LIST_NEW_SECTION').toString(), {
      editAfterAdding: false,
      addToSelectedDepth: true,
    });

    this.platformDisplayOption = 'NONE';
  }

  private updateTrees(groupNo: number, text: string): void {
    this.trees = clone(this.trees).map(tree => {
      if (tree.groupNo === groupNo) {
        tree.text = text;
      }

      return tree;
    });
  }

  private deleteTree(): void {
    this.tuiTree.deleteTree();
    this.acceptLeave = true;
  }

  private savePrevData(){
    sessionStorage.setItem('beforeCommonData', JSON.stringify(this.commonData));
    sessionStorage.setItem('beforeAccountsData', JSON.stringify(this.accountsData));
  }

  private onChangeTree(changeTreeData: ChangeSelectTreeEmit): void {
    this.isGroupTree = changeTreeData.depth === 1;
    this.commonData.title = changeTreeData.nodeData.text;
    this.prevCommonTitle = changeTreeData.nodeData.text;
    this.commonData.groupNo = changeTreeData.parentData.groupNo || changeTreeData.nodeData.groupNo || this.groupNo;
    this.commonData.sectionNo = changeTreeData.parentData.groupNo ? changeTreeData.nodeData.sectionNo : 0;
    if (this.isGroupTree) return;
    //배너 데이터 변경 후 섹션 추가할때
    if(this.isSectionAdditionAfterSaving && this.isClickAddSection) {
     this.savePrevData()
      this.addSectionTree(false)
      this.isClickAddSection = false
      return
    }
    this.fetchSectionData(changeTreeData.nodeData.sectionNo, this.isNewBorn);
    this.isNewBorn = false;
  }

  private onClickCreateBanner(sectionIdx: number): void {
    const howManyBanners: number = this.accountsData[sectionIdx].banners.length;

    if (howManyBanners > 100) {
      alert(this.$t('BANNER_LIST_ALERT_BANNER_LIMIT'));
    }

    this.addNewBanner(sectionIdx, howManyBanners);
  }

  private onClickDeleteBanner(sectionIdx: number, idx: number): void {
    if (!confirm(this.$t('BANNER_LIST_CONFILM_DELETE_BANNER').toString())) return;

    this.deleteBanner(sectionIdx, idx);
  }

  private addNewBanner(sectionIdx: number, howManyBanners: number): void {
    const temporaryAccountsData = clone(this.accountsData);

    if (howManyBanners === 0) temporaryAccountsData[sectionIdx].banners = [this.defaultBannerData(howManyBanners + 1)];
    if (howManyBanners > 0) temporaryAccountsData[sectionIdx].banners.push(this.defaultBannerData(howManyBanners + 1));
    this.accountsData = temporaryAccountsData;
  }

  private deleteBanner(sectionIdx: number, idx: number): void {
    let temporaryAccountsData = clone(this.accountsData);
    const isJustOne: boolean = temporaryAccountsData[sectionIdx].banners.length === 1;
    if (isJustOne) {
      temporaryAccountsData.splice(sectionIdx, 1)
    } else {
      temporaryAccountsData[sectionIdx].banners.splice(idx, 1);
    }
    this.accountsData = temporaryAccountsData;
  }

  private bannerIndexToSwap(outerIdx: number, idx: number, lastIdx?: number): void {
    const inabilityToMove: boolean = (lastIdx && idx === lastIdx) || (!lastIdx && idx === 0);
    if (inabilityToMove) return;
    const moveType: 'up' | 'down' = !lastIdx ? 'up' : 'down';

    const targetIndex = moveType === 'up' ? idx - 1 : idx + 1;

    this.accountsData[outerIdx].banners = arrayElementSwap<GetBannerGroupsBanner>(
      this.accountsData[outerIdx].banners,
      targetIndex,
      idx,
    ).map((banner, i) => {
      banner.displayOrder = i + 1;
      return banner;
    });
  }
  private onUploadProxyButtonClicked(
    inputElements: HTMLInputElement[],
    sectionIndex: number,
    bannerIndex: number,
  ): void {
    inputElements.some((fileElement: HTMLInputElement) => {
      const fileSectionIdx = fileElement.getAttribute('data-outer-index');
      const fileBannerIdx = fileElement.getAttribute('data-index');
      if (sectionIndex === Number(fileSectionIdx) && bannerIndex === Number(fileBannerIdx)) {
        fileElement.click();
        return true;
      }
    });
  }
  private uploadImageFile(e: Event, imageState: Image) {
    const file: File = ((e.target as HTMLInputElement).files as FileList)[0];
    this.uploadFile(file, data => {
      imageState.imageName = file.name;
      imageState.imageUrl = data.url;
    });
  }

  private resetImageFile(imageState: Image): void {
    imageState.imageName = '';
    imageState.imageUrl = '';
  }

  private uploadFile(file: File, callback: (data) => void): void {
    const limit = 1024000;

    if (file.size > limit) {
      alert(this.$t('BANNER_LIST_ALERT_IMAGE_SIZE_OVER'));
      return;
    }

    const loaderElement: HTMLElement = document.getElementById('loading');
    const data = new FormData();
    data.append('file', file);

    loaderElement.style.display = 'block';

    this.$api.postImages({ data, params: { mallNo: parseInt(this.mallNo, 10) } }).then(request => {
      loaderElement.style.display = 'none';
      callback(request.data);
    });
  }

  private onDeleteImageMap(mapData: LandingUrl): void {
    if (confirm(this.$t('BANNER_LIST_CONFIRM_PERMANENT_DELETE').toString())) {
      mapData.landingUrl = '';
    }
  }

  private onChangeImageMap(data: { imageMap: string }, mapData: LandingUrl): void {
    mapData.landingUrl = data.imageMap;
  }

  private onChangeColor(colorHexCode: string, banner: Banner, keyName: string): void {
    banner[keyName] = colorHexCode;
  }

  private onChangeDescription(data: BannerDescriptionPopupProp, banner: Banner): void {
    banner.description = data.description;
    banner.descriptionColor = data.colorHexCode;
  }

  private onDeleteDescription(banner: Banner): void {
    if (confirm(this.$t('BANNER_LIST_CONFIRM_PERMANENT_DELETE').toString())) {
      banner.description = '';
      // @legacy : banner.descriptionColor = ''
    }
  }

  private onChangePeriod(periodType: 'REGULAR' | 'PERIOD', outerIdx: number, idx: number) {
    if (periodType === 'REGULAR') this.setRegularEndPeriod(outerIdx, idx);
    if (periodType === 'PERIOD') this.setDefaultEndPeriod(outerIdx, idx);
  }

  private validateDisplayPeriod(
    validTarget: 'start' | 'end',
    oldValue: string,
    period: DisplayPeriod,
    outerIdx: number,
    idx: number,
  ): void {
    this.$nextTick(() => {
      const startDateTime = moment(period.startYmdt)
        .toDate()
        .getTime();
      const newEndDateTime = moment(period.endYmdt)
        .toDate()
        .getTime();

      const overflow = startDateTime > newEndDateTime;

      if (!overflow) return;
      if (validTarget === 'start') {
        this.accountsData[outerIdx].banners[idx].displayPeriod.displayPeriod.startYmdt = oldValue;
      }
      if (validTarget === 'end') {
        this.accountsData[outerIdx].banners[idx].displayPeriod.displayPeriod.endYmdt = oldValue;
      }
      return alert(this.$t('COMMON_DATE_SPAN_ERR'));
    });
  }

  private setRegularEndPeriod(outerIdx: number, idx: number): void {
    this.accountsData[outerIdx].banners[idx].displayPeriod.displayPeriod.endYmdt = '2099-12-31 23:59:59';
  }

  private setDefaultEndPeriod(outerIdx: number, idx: number): void {
    const displayPeriod = this.accountsData[outerIdx].banners[idx].displayPeriod.displayPeriod;
    const defaultEndPeriod = addMonth(moment(displayPeriod.startYmdt).toDate(), 3);

    displayPeriod.endYmdt = `${defaultEndPeriod} 23:59:59`;
  }

  private onPopupBannerDisplayOptionOpen(sectionNo: number): void {
    const popup = ncpPopup(`/banner/displayConfig?&mallNo=${this.mallNo}&sectionNo=${sectionNo}`, '_blank', 900, 485);

    popup.addEventListener('DOMContentLoaded', () => {
      popup['parentData'] = this.getPopupBannerDisplayData(sectionNo);
    });

    window.emitChildData = this.emitChildData;
  }

  private getPopupBannerDisplayData(sectionNo: number): PopupBannerDisplayOptionData {
    const memberGradeDetailDisplayOptions = clone(this.memberGradeDetailDisplayOptions);
    const memberGroupDetailDisplayOptions = clone(this.memberGroupDetailDisplayOptions);

    const { memberGradeDisplay, memberGroupDisplay } = this.commonData;
    if (memberGradeDisplay.check === 'ANY' && memberGradeDisplay.info !== 'ALL') {
      memberGradeDetailDisplayOptions.data = this.getFilteredCheckBoxOptionData(
        memberGradeDetailDisplayOptions.data,
        memberGradeDisplay.info,
      );
    }

    if (memberGroupDisplay.check === 'ANY' && memberGroupDisplay.info !== 'ALL') {
      memberGroupDetailDisplayOptions.data = this.getFilteredCheckBoxOptionData(
        memberGroupDetailDisplayOptions.data,
        memberGroupDisplay.info,
      );
    }

    return {
      // deep copy(clone) 안하면 팝업에서 cancel 시 문제 발생
      accountData: clone(this.accountsData[sectionNo]),
      commonData: clone(this.commonData),
      memberGradeDetailDisplayOptions,
      memberGroupDetailDisplayOptions,
    };
  }

  private getFilteredCheckBoxOptionData(data: CheckBoxOptionData[], info: string): CheckBoxOptionData[] {
    const values = info.includes(',') ? info.split(',') : [info];

    return data.filter(({ value }) => {
      if (value === 'ALL') return true;
      return values.some(v => v === value);
    });
  }

  private emitChildData(data: AccountData, sectionNo: number): void {
    const accountsData = clone(this.accountsData);

    accountsData[sectionNo].displayType = data.displayType;
    accountsData[sectionNo].platformDisplay = data.platformDisplay;
    accountsData[sectionNo].memberGradeDisplayInfo = data.memberGradeDisplayInfo;
    accountsData[sectionNo].memberGroupDisplayInfo = data.memberGroupDisplayInfo;

    this.accountsData = accountsData;
  }

  private wrongAccessHandler(errorMessage) {
    alert(errorMessage);
    this.acceptLeave = true;
    this.fetchBannerGroups();
  }

  beforeDestroy() {
    this.cleanUpSessionStorage();
  }

  private cleanUpSessionStorage(): void {
    sessionStorage.removeItem('beforeCommonData');
    sessionStorage.removeItem('beforeAccountsData');
  }
}
